import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import Overlay from '../../legos/Overlay';
import ErrorBoundary from '../../../../ErrorBoundary';
import { getDeviationTitle } from '../../../_helpers';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import PollOverlay from './PollOverlay';
import s from './PollThumb.scss';
var PollThumb = function (_a) {
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions;
    var _b = useOverlayContext(deviation), showOverlay = _b.showOverlay, __forceHoveredForStories = _b.__forceHoveredForStories;
    return (React.createElement(HoverableWrapper, { className: classnames(s['root'], className), style: __assign({ width: width, height: height }, style), __forceHoveredForStories: __forceHoveredForStories },
        React.createElement(ErrorBoundary, { debugComponent: "PollThumb" },
            React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }),
            React.createElement(DeviationLink, { deviation: deviation, className: s['link'], title: getDeviationTitle(deviation) },
                React.createElement("span", null)),
            showOverlay && (React.createElement(Overlay, { deviation: deviation, width: width, height: height, className: s['overlay'], extraActions: extraActions },
                React.createElement(PollOverlay, { className: s['poll-overlay'], deviation: deviation }))))));
};
PollThumb.displayName = 'PollThumb';
export default PollThumb;
//# sourceMappingURL=PollThumb.js.map